import React, { useState } from "react";
import { supabase } from "../lib/supabase";

const TokenDebugger = () => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [results, setResults] = useState(null);

  const debugByEmail = async () => {
    try {
      const { data, error } = await supabase
        .from("profiles")
        .select(
          `
          id,
          email,
          email_verified,
          email_verification_token,
          email_verification_sent_at,
          email_verification_expires_at
        `
        )
        .eq("email", email)
        .single();

      setResults({
        type: "email",
        data,
        error: error?.message,
        tokenExists: !!data?.email_verification_token,
        tokenExpired: data?.email_verification_expires_at
          ? new Date(data.email_verification_expires_at) < new Date()
          : null,
        alreadyVerified: data?.email_verified,
      });
    } catch (err) {
      setResults({ type: "email", error: err.message });
    }
  };

  const debugByToken = async () => {
    try {
      const { data, error } = await supabase
        .from("profiles")
        .select(
          `
          id,
          email,
          email_verified,
          email_verification_token,
          email_verification_sent_at,
          email_verification_expires_at
        `
        )
        .eq("email_verification_token", token)
        .single();

      setResults({
        type: "token",
        data,
        error: error?.message,
        tokenExists: !!data?.email_verification_token,
        tokenExpired: data?.email_verification_expires_at
          ? new Date(data.email_verification_expires_at) < new Date()
          : null,
        alreadyVerified: data?.email_verified,
      });
    } catch (err) {
      setResults({ type: "token", error: err.message });
    }
  };

  const testVerifyFunction = async () => {
    try {
      const { data, error } = await supabase.rpc("verify_email", {
        verification_token: token,
      });

      setResults({
        type: "function",
        data,
        error: error?.message,
        functionWorks: !!data,
      });
    } catch (err) {
      setResults({ type: "function", error: err.message });
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Token Debugger</h2>

      <div className="space-y-4">
        <div>
          <label className="block font-semibold mb-2">Debug by Email:</label>
          <div className="flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
              className="flex-1 border rounded px-3 py-2"
            />
            <button
              onClick={debugByEmail}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Debug
            </button>
          </div>
        </div>

        <div>
          <label className="block font-semibold mb-2">Debug by Token:</label>
          <div className="flex gap-2">
            <input
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Enter verification token"
              className="flex-1 border rounded px-3 py-2"
            />
            <button
              onClick={debugByToken}
              className="bg-green-500 text-white px-4 py-2 rounded"
            >
              Debug
            </button>
          </div>
        </div>

        <div>
          <button
            onClick={testVerifyFunction}
            disabled={!token}
            className="bg-purple-500 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            Test Verify Function
          </button>
        </div>
      </div>

      {results && (
        <div className="mt-6 p-4 bg-gray-100 rounded">
          <h3 className="font-bold mb-2">Debug Results ({results.type}):</h3>
          <pre className="text-sm overflow-auto">
            {JSON.stringify(results, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TokenDebugger;
